module.exports = __webpack_public_path__ + "static/media/rose-prick.2a71ccb1.png";